import { useParams, Link } from 'react-router-dom';
import { articleList, categories } from '@/mocks/articles';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articleList.find((a) => a.slug === slug);

  const articleCovers: Record<number, string> = {
    1: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20lighting%20and%20warm%20tones%2C%20movie%20set%20atmosphere%20with%20vintage%20camera%20equipment%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style%2C%20rich%20colors%20and%20deep%20shadows%2C%20artistic%20composition&width=1200&height=600&seq=article-detail-01&orientation=landscape',
    2: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20studio%20interior%20with%20modern%20equipment%2C%20cameras%20and%20lighting%20rigs%2C%20warm%20ambient%20lighting%2C%20clean%20organized%20workspace%2C%20cinematic%20production%20atmosphere%2C%20high-end%20professional%20photography&width=1200&height=600&seq=article-detail-02&orientation=landscape',
    3: 'https://readdy.ai/api/search-image?query=Premium%20lifestyle%20scene%20with%20golden%20warm%20tones%2C%20elegant%20interior%20setting%20with%20comfortable%20sofa%20and%20tablet%20device%2C%20cozy%20atmosphere%20with%20soft%20lighting%2C%20modern%20minimal%20design%2C%20luxurious%20yet%20accessible%20feeling&width=1200&height=600&seq=article-detail-03&orientation=landscape',
    4: 'https://readdy.ai/api/search-image?query=Person%20holding%20smartphone%20filming%20outdoor%20scene%20with%20beautiful%20natural%20lighting%2C%20golden%20hour%20photography%2C%20urban%20background%20with%20warm%20sunset%20tones%2C%20creative%20mobile%20filmmaking%2C%20casual%20lifestyle%20photography&width=1200&height=600&seq=article-detail-04&orientation=landscape',
    5: 'https://readdy.ai/api/search-image?query=Intimate%20live%20music%20performance%20scene%20with%20warm%20stage%20lighting%2C%20acoustic%20guitar%20player%20on%20small%20stage%2C%20atmospheric%20venue%20with%20soft%20amber%20spotlights%2C%20indie%20music%20concert%20photography%2C%20artistic%20moody%20atmosphere&width=1200&height=600&seq=article-detail-05&orientation=landscape',
    6: 'https://readdy.ai/api/search-image?query=Street%20food%20scene%20in%20Asian%20night%20market%20with%20steam%20rising%20from%20food%20stalls%2C%20warm%20tungsten%20lighting%2C%20colorful%20food%20displays%2C%20bustling%20atmosphere%2C%20food%20photography%20with%20shallow%20depth%20of%20field%2C%20authentic%20cultural%20experience&width=1200&height=600&seq=article-detail-06&orientation=landscape',
    7: 'https://readdy.ai/api/search-image?query=Modern%20tech%20gadgets%20arranged%20on%20clean%20minimalist%20desk%2C%20smartphone%20smartwatch%20wireless%20earbuds%2C%20natural%20light%20from%20window%2C%20product%20photography%20with%20neutral%20background%2C%20sleek%20contemporary%20design%20aesthetic&width=1200&height=600&seq=article-detail-07&orientation=landscape',
    8: 'https://readdy.ai/api/search-image?query=Elderly%20artisan%20working%20with%20traditional%20craft%20tools%20in%20rustic%20workshop%2C%20warm%20natural%20light%20through%20window%2C%20wooden%20textures%20and%20hand%20tools%2C%20documentary%20photography%20style%2C%20authentic%20cultural%20heritage%20atmosphere&width=1200&height=600&seq=article-detail-08&orientation=landscape',
  };

  if (!article) {
    return (
      <main className="min-h-screen pt-24 px-4 md:px-6 bg-background-50">
        <div className="max-w-3xl mx-auto text-center py-20">
          <div className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-file-unknow-line text-foreground-400 text-2xl w-8 h-8 flex items-center justify-center"></i>
          </div>
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-2">文章未找到</h1>
          <p className="text-sm text-foreground-500 mb-6">您要查看的文章不存在或已被移除</p>
          <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer">
            返回首页
          </Link>
        </div>
      </main>
    );
  }

  const category = categories.find((c) => c.id === article.category);
  const relatedArticles = articleList
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, 3);

  const relatedCovers: Record<number, string> = {
    1: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20lighting%20and%20warm%20tones%2C%20movie%20set%20atmosphere%20with%20vintage%20camera%20equipment%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style&width=640&height=360&seq=related-01&orientation=landscape',
    2: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20studio%20interior%20with%20modern%20equipment%2C%20cameras%20and%20lighting%20rigs%2C%20warm%20ambient%20lighting%2C%20cinematic%20production%20atmosphere&width=640&height=360&seq=related-02&orientation=landscape',
    3: 'https://readdy.ai/api/search-image?query=Premium%20lifestyle%20scene%20with%20golden%20warm%20tones%2C%20elegant%20interior%20setting%20with%20comfortable%20sofa%2C%20cozy%20atmosphere%20with%20soft%20lighting%2C%20modern%20minimal%20design&width=640&height=360&seq=related-03&orientation=landscape',
    4: 'https://readdy.ai/api/search-image?query=Person%20holding%20smartphone%20filming%20outdoor%20scene%20with%20beautiful%20natural%20lighting%2C%20golden%20hour%20photography%2C%20urban%20background%20with%20warm%20sunset%20tones&width=640&height=360&seq=related-04&orientation=landscape',
    5: 'https://readdy.ai/api/search-image?query=Intimate%20live%20music%20performance%20scene%20with%20warm%20stage%20lighting%2C%20acoustic%20guitar%20player%2C%20atmospheric%20venue%20with%20soft%20amber%20spotlights&width=640&height=360&seq=related-05&orientation=landscape',
    6: 'https://readdy.ai/api/search-image?query=Street%20food%20scene%20in%20Asian%20night%20market%20with%20steam%20rising%2C%20warm%20tungsten%20lighting%2C%20colorful%20food%20displays%2C%20bustling%20atmosphere&width=640&height=360&seq=related-06&orientation=landscape',
    7: 'https://readdy.ai/api/search-image?query=Modern%20tech%20gadgets%20arranged%20on%20clean%20minimalist%20desk%2C%20smartphone%20smartwatch%2C%20natural%20light%2C%20product%20photography%20neutral%20background&width=640&height=360&seq=related-07&orientation=landscape',
    8: 'https://readdy.ai/api/search-image?query=Elderly%20artisan%20working%20with%20traditional%20craft%20tools%20in%20rustic%20workshop%2C%20warm%20natural%20light%2C%20authentic%20cultural%20heritage%20atmosphere&width=640&height=360&seq=related-08&orientation=landscape',
  };

  const escapedContent = article.content.replace(/'/g, "\\'").replace(/\n/g, '\\n');

  return (
    <>
      <article className="min-h-screen pt-20 pb-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: category?.name || '分类', path: `/category/${article.category}` },
                { label: article.title },
              ]}
            />
          </div>

          <header className="mb-8">
            <div className="flex items-center gap-2 flex-wrap mb-4">
              {article.tags.map((tag) => (
                <span key={tag} className="bg-secondary-100 text-secondary-700 text-xs px-2.5 py-1 rounded-full">
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>

            <div className="flex items-center gap-4 text-xs text-foreground-500 flex-wrap">
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-user-line w-3.5 h-3.5 flex items-center justify-center"></i></span>
                {article.author}
              </span>
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center"></i></span>
                {article.publishDate}
              </span>
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i></span>
                阅读 {article.readTime}
              </span>
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i></span>
                {(article.views / 10000).toFixed(1)}万 阅读
              </span>
            </div>
          </header>

          <div className="aspect-video rounded-xl overflow-hidden mb-8">
            <img
              src={articleCovers[article.id]}
              alt={article.title}
              title={`${article.title} - 麻豆视频`}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div
            className="prose prose-sm max-w-none text-foreground-800 leading-relaxed article-content"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div className="flex items-center gap-2">
                <span className="text-xs text-foreground-500">分享到：</span>
                <button className="w-8 h-8 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors cursor-pointer" aria-label="分享到微信">
                  <i className="ri-wechat-line text-foreground-600 w-4 h-4 flex items-center justify-center"></i>
                </button>
                <button className="w-8 h-8 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors cursor-pointer" aria-label="分享到微博">
                  <i className="ri-weibo-line text-foreground-600 w-4 h-4 flex items-center justify-center"></i>
                </button>
                <button className="w-8 h-8 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors cursor-pointer" aria-label="复制链接">
                  <i className="ri-link text-foreground-600 w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
              <div className="flex items-center gap-3">
                <Link to={`/category/${article.category}`} className="text-xs text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer">
                  <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-arrow-left-line w-3 h-3 flex items-center justify-center"></i></span>
                  返回{category?.name || '分类'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </article>

      {relatedArticles.length > 0 && (
        <section className="py-14 px-4 md:px-6 bg-background-100/50">
          <div className="max-w-7xl mx-auto">
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-6">相关推荐</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {relatedArticles.map((ra) => (
                <Link
                  key={ra.id}
                  to={`/article/${ra.slug}`}
                  className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-200 border border-background-200/60"
                >
                  <div className="relative aspect-video overflow-hidden">
                    <img
                      src={relatedCovers[ra.id]}
                      alt={ra.title}
                      title={`${ra.title} - 麻豆视频`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    />
                  </div>
                  <div className="p-4">
                    <span className="text-xs text-primary-600 font-medium">
                      {categories.find((c) => c.id === ra.category)?.name}
                    </span>
                    <h4 className="text-sm font-semibold text-foreground-900 mt-1.5 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                      {ra.title}
                    </h4>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            author: { '@type': 'Person', name: article.author },
            datePublished: article.publishDate,
            image: articleCovers[article.id],
            publisher: {
              '@type': 'Organization',
              name: '麻豆视频',
            },
          }),
        }}
      />
    </>
  );
}